import { API_V2 } from './apiVersion';

export const PLAY_GAME_ENDPOINTS = {
  LIST_BY_STORE: (storeId: number) =>
    `${API_V2}/play-games/store/${storeId}`,

  DETAIL: (playGameId: number) =>
    `${API_V2}/play-games/${playGameId}`,

  ADMIN: {
    CREATE: `${API_V2}/admin/play-games`,

    START: (playGameId: number) =>
      `${API_V2}/admin/play-games/${playGameId}/start`,

    PAUSE: (playGameId: number) =>
      `${API_V2}/admin/play-games/${playGameId}/pause`,

    RESUME: (playGameId: number) =>
      `${API_V2}/admin/play-games/${playGameId}/resume`,

    FINISH: (playGameId: number) =>
      `${API_V2}/admin/play-games/${playGameId}/finish`,

    JOIN_USER: (playGameId: number) =>
      `${API_V2}/admin/play-games/${playGameId}/players`,

    JOIN_GUEST: (playGameId: number) =>
      `${API_V2}/admin/play-games/${playGameId}/guest-players`,

    PLAYER: (
      playGameId: number,
      userGameId: number,
    ) =>
      `${API_V2}/admin/play-games/${playGameId}/players/${userGameId}`,

    APPROVE_PLAYER: (
      playGameId: number,
      userGameId: number,
    ) =>
      `${API_V2}/admin/play-games/${playGameId}/players/${userGameId}/approve`,

    OUT_PLAYER: (
      playGameId: number,
      userGameId: number,
    ) =>
      `${API_V2}/admin/play-games/${playGameId}/players/${userGameId}/out`,

    REBUY: (
      playGameId: number,
      userGameId: number,
    ) =>
      `${API_V2}/admin/play-games/${playGameId}/players/${userGameId}/rebuy`,

    CANCEL_REBUY: (
      playGameId: number,
      userGameId: number,
    ) =>
      `${API_V2}/admin/play-games/${playGameId}/players/${userGameId}/rebuy/cancel`,

    EARLY_INCREASE: (playGameId: number) =>
      `${API_V2}/admin/play-games/${playGameId}/early/increase`,

    EARLY_DECREASE: (playGameId: number) =>
      `${API_V2}/admin/play-games/${playGameId}/early/decrease`,

    NEXT_LEVEL: (playGameId: number) =>
      `${API_V2}/admin/play-games/${playGameId}/levels/next`,

    PREV_LEVEL: (playGameId: number) =>
      `${API_V2}/admin/play-games/${playGameId}/levels/prev`,

    PRIZES: (playGameId: number) =>
      `${API_V2}/admin/play-games/${playGameId}/prizes`,

    PAYMENT: (userGameId: number) =>
      `${API_V2}/admin/play-games/players/${userGameId}/payment`,

    CANCEL_PAYMENT: (userGameId: number) =>
      `${API_V2}/admin/play-games/players/${userGameId}/payment/cancel`,

    PAYMENT_MEMO: (userGameId: number) =>
      `${API_V2}/admin/play-games/players/${userGameId}/payment/memo`,
  },
} as const;
